export default __webpack_public_path__ + "static/sports_small-70ee08e2922bda8f9e10c5400a8f6616.webp";